import { useCappsResidenceWebApiHandler_validateAddress } from '@zg-rentals/ts-capps-client-react-query';

export type AddressToValidate = {
  city: string;
  state: string;
  zipcode: string;
};

export function useValidateAddress() {
  const { mutateAsync } = useCappsResidenceWebApiHandler_validateAddress({
    meta: { context: { api: 'cappsResidence', details: 'validateAddress' } },
  });

  // A network/server error must not block the applicant, so it counts as a valid address.
  return (address: AddressToValidate) =>
    mutateAsync({ getParams: address }).catch(() => ({ isValid: true, errorMessage: '', errorCode: '' }));
}
